import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CommonModule} from '@angular/common';
import {DashboardComponent} from '@components/dashboard/dashboard.component';
import {AuthorizationGuardService} from '../../shared/authorization-guard/authorization-guard.service';

const routes: Routes = [
  {path: 'dashboard', component: DashboardComponent, canActivate: [AuthorizationGuardService]},
  {path: 'dashboard/:id', component: DashboardComponent, canActivate: [AuthorizationGuardService]}
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class DashboardRoutingModule {
}
